export default {"src":"/_next/static/media/Oval.c3c09721.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};